import { initialState } from "./state";

export const setSubscriptionList = (state, payload) => {
  state.subscriptionList = payload;
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
